import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { publicApi } from '../lib/api.ts';
import { CenteredSpinner } from '../components/Spinner.tsx';
import { AuthNotice } from '../components/AuthSplitLayout.tsx';

// Redeems the 2-day HMAC login token emailed to the vendor: swaps it for a
// Supabase magic-link action_link, then hands off to /c/callback. Mirrors
// DriverLanding.
export function CompanyLinkRedeem() {
  const { token = '' } = useParams();
  const [error, setError] = useState<unknown>(null);
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;
    if (!token) {
      setError(new Error('Missing login token'));
      return;
    }
    publicApi
      .post<{ action_link: string }>('/api/auth/company/redeem', { token })
      .then((body) => {
        if (!body?.action_link) throw new Error('Redeem returned no action link');
        window.location.href = body.action_link;
      })
      .catch((err) => setError(err));
  }, [token]);

  if (error) {
    return (
      <AuthNotice variant="vendor" title="This sign-in link didn’t work" error={error}>
        It may have expired or already been used. Request a new one from the sign-in page.
      </AuthNotice>
    );
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50">
      <CenteredSpinner />
      <p className="text-sm text-slate-500">Preparing your sign-in…</p>
    </div>
  );
}
